import TopNav from 'components/TopNav'
import { Tab, Tabs } from '@mui/material'
import SwipeableViews from 'react-swipeable-views'
import { Link, Outlet, useLocation, useMatch, useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'
import { startCase } from 'lodash'
import { usePharmacy } from 'data/pharmacy'

export default function Medications() {
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(() => {
    return location.pathname.includes('treatments') ? 'treatments' : 'medications'
  })
  const tabs = ['treatments', 'medications']
  const { data: pharmacy } = usePharmacy(id as string)

  return (
    <div className="grid">
      {pharmacy && <TopNav title={`${pharmacy?.pharmacy_name} Pharmacy`} />}

      <div className="mt-4">
        <Tabs
          value={activeTab}
          variant="fullWidth"
          TabIndicatorProps={{
            children: <span className="MuiTabs-indicatorSpan" />,
            className: 'h-full bg-white lg:rounded-lg',
          }}
          onChange={(_, value) => {
            navigate(value, { replace: true })
            setActiveTab(value)
          }}
          className="border h-10 w-full rounded-lg mt-4 lg:w-[39rem] mx-auto"
        >
          {tabs.map((item, index) => (
            <Tab
              key={index}
              label={startCase(item)}
              to={item}
              component={Link}
              id={item}
              value={item}
              aria-controls="pending-tab-panel"
              className={`${
                activeTab === item ? 'text-white bg-neutral-400' : 'text-neutral-400'
              } capitalize z-50`}
              replace
            />
          ))}
        </Tabs>

        <div className="mx-auto mt-4 grid grid-cols-1">
          <SwipeableViews
            index={tabs.indexOf(activeTab)}
            onChangeIndex={(index) => {
              navigate(index === 0 ? 'treatments' : 'medications')
              setActiveTab(tabs[index])
            }}
            value={activeTab}
            resistance
            enableMouseEvents
            className="w-full"
          >
            <div>
              <Outlet />
            </div>
            <div>
              <Outlet />
            </div>
          </SwipeableViews>
        </div>
      </div>
    </div>
  )
}
